/**
 * ab=treatment パラメータによるアプリ導線非表示制御の共通mixin
 */
export default {
  computed: {
    isAbTreatment() {
      // Vue Routerの$route.queryを使用して安全にパラメータを取得
      return this.$route?.query?.ab === 'treatment';
    },
    shouldHideForAbTreatment() {
      if (!this.isAbTreatment) return false;

      const hiddenPids = [
        'smart_banner',
        'web_cart',
        'web_browser_switch_modal',
        'web_cart_modal_from_meta',
        'web_cart_onlinecheckin',
        'web_cart_mileage',
        'web_cart_modal_not_from_meta',
        'mypage_line',
        'mypage',
        'web_header_modal',
      ];

      // 各コンポーネントで使用するPIDを指定
      const currentPid = this.getCurrentPid();
      return hiddenPids.includes(currentPid);
    },
  },
  methods: {
    /**
     * 現在のコンポーネントで使用するPIDを取得
     * 各コンポーネントでオーバーライドして実装
     */
    getCurrentPid() {
      throw new Error('getCurrentPid method must be implemented in component');
    },
  },
};
